import { mapGetters, mapActions } from 'vuex';
import { GcButton } from '@garmin/components-global';
import VueCookies from 'vue-cookies';
import ProductWarning from '@/components/ProductWarning/index.vue';

export default {
  name: 'CtasWrapper',
  components: {
    ProductWarning,
    GcButton,
  },
  data() {
    return {
      className: 'app__product__cta',
      ctaJsId: 'js__cta',
      jsId: 'js__product__ctas',
    };
  },
  computed: {
    buyJsId() {
      return `${this.ctaJsId}__buy`;
    },
    dealerJsId() {
      return `${this.ctaJsId}__dealer`;
    },
    warningJsId() {
      return `${this.ctaJsId}__warning`;
    },
    btnClassName() {
      return `${this.className}__button`;
    },
    buyBtnClassName() {
      return `${this.btnClassName}__buy`;
    },
    dealerBtnClassName() {
      return `${this.btnClassName}__dealer`;
    },
    ctaLoadingClassName() {
      return `${this.className}__loading`;
    },
    ...mapGetters({
      productName: 'getProductName',
      productVariation: 'getProductVariation',
      galleryImageList: 'getGalleryImageList',
      interstitialErrorMessage: 'getInterstitialApiErrorMessage',
      hasInterstitialAccessories: 'getHasInterstitialAccessories',
      productPageApi: 'getProductPageApi',
    }),
  },
  methods: {
    addToCartOldFlow(url) {
      window.location.assign(url);
    },
    async btnClick(event) {
      const url = event.target.href;
      let interrupt = false;

      // redirect to cart url if no compatible products are available
      if (!this.hasInterstitialAccessories) return;

      event.preventDefault();
      this.setAddToCartLoading(true);

      // Error message in case something fails
      const errMsg = ['warning', this.interstitialErrorMessage, null];
      this.removeFlashMessage(0);

      // Adding the product to cart
      const options = {
        method: 'GET',
        credentials: 'include',
      };

      // If we don't have the GarminCart cookie we need to make this request that will set it
      if (!VueCookies.get('GarminCart')) {
        await fetch(`${this.productPageApi}/getCart`).catch(() => {
          interrupt = true;
          this.setFlashMessage(errMsg);
        });
      }

      const addRequest = await fetch(url, options).catch(() => {
        interrupt = true;
        this.addToCartOldFlow(url);
      });

      // Check if request failed. If it did we hard redirect to adding the item as previosuly
      if (addRequest && !addRequest.ok) {
        this.addToCartOldFlow(url);
        return;
      }

      // If an error occured while adding the product return to product
      if (interrupt) {
        this.setAddToCartLoading(false);
        return;
      }

      // Trigger update for the cart count in the header
      this.updateCartCount();

      this.setInterstitialIsVisible(true);
      this.setInterstitialProductDetails({
        name: this.productName,
        variation: this.productVariation,
        imageSrc: this.galleryImageList.length && this.galleryImageList[0].imageSrc,
        altText: this.galleryImageList.length && this.galleryImageList[0].altText,
      });

      this.setAddToCartLoading(false);
    },
    updateCartCount() {
      const event = document.createEvent('Event');
      event.initEvent('cartCountChanged', true, false);
      document.dispatchEvent(event);
    },
    ...mapActions([
      'setInterstitialIsVisible',
      'setInterstitialProductDetails',
      'setFlashMessage',
      'removeFlashMessage',
    ]),
  },
  props: {
    showNewAddToCartBt: {
      type: Boolean,
      default: false,
    },
    showOldAddToCartBt: {
      type: Boolean,
      default: false,
    },
    addToCartLoading: {
      type: Boolean,
      default: false,
    },
    setAddToCartLoading: {
      type: Function,
      default: () => null,
    },
    newAddToCartHref: {
      type: String,
      default: '',
    },
    oldAddToCartHref: {
      type: String,
      default: '',
    },
    newAddToCartText: {
      type: String,
      default: '',
    },
    oldAddToCartText: {
      type: String,
      default: '',
    },
    showDealerBt: {
      type: Boolean,
      default: false,
    },
    dealerHref: {
      type: String,
      default: '',
    },
    dealerText: {
      type: String,
      default: '',
    },
    expressWarning: {
      type: String,
      default: '',
    },
    showExpressWarning: {
      type: Boolean,
      default: true,
    },
  },
};
